import {isDarkModeActive, toggleDarModeStatement} from '../utilities/domGeneralManipulation.js';
import {disableAllMegaMenu, getNavStatus} from './navigation.js';

const domElements = {
    searchTrigger: document.querySelectorAll('.header-icons-item__button--search-trigger'),
    header: document.querySelector('.header'),
    isActive: false
}

export const getSearchStatus = () => domElements.isActive;

export const disableSearch = () => {
    domElements.isActive = false;
    domElements.header.classList.remove('search-active');
    domElements.searchTrigger.forEach(item => item.closest('.header-icons-item').classList.remove('active'));
}

export default () => {
    domElements.searchTrigger.forEach(item => item.addEventListener('click', (e) => {
        e.preventDefault();
        
        if(getNavStatus()) {
            disableAllMegaMenu();
        }

        if(isDarkModeActive() && !domElements.isActive) {
            domElements.isActive = true;
        } else {
            toggleDarModeStatement(true);
            domElements.isActive = !domElements.isActive;
        }

        const searchTriggerWrapper = item.closest('.header-icons-item');
        searchTriggerWrapper.classList.toggle('active');
        domElements.header.classList.toggle('search-active');
    }));
    
}
